//Reference: https://www.positronx.io/full-angular-firebase-authentication-system/

import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { AuthService } from '../_services/authentication.service';
import { CharacterSheetService } from '../_services/character-sheet.service';
import { Joueur } from '../_models/joueur';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  joueur!: Joueur;

  constructor(public authService: AuthService, private characterSheetService: CharacterSheetService) {}
  ngOnInit(): void {
    
    this.characterSheetService.getJoueur()          
    .pipe(first())
    .subscribe({
      next: (joueur) => this.joueur = joueur,
    });

  }
}